import initialState from './initialState';
import {
  REPORT_FILE_ADMIN_GET_GROUPS_INIT,
  REPORT_FILE_ADMIN_GET_GROUPS_SUCCESS,
  REPORT_FILE_ADMIN_GET_GROUPS_FAILURE,
  REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_INIT,
  REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_SUCCESS,
  REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_FAILURE,
  REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_INIT,
  REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_SUCCESS,
  REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_FAILURE,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_INIT,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_SUCCESS,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_FAILURE,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_INIT,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SUCCESS,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_FAILURE,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_INIT,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_SUCCESS,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_FAILURE,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_INIT,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_SUCCESS,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_FAILURE,     
  REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_INIT,
  REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_SUCCESS,
  REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_FAILURE,
  REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_INIT,
  REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_SUCCESS,
  REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_FAILURE,
  REPORT_FILE_ADMIN_DELETE_REPORT_FILE_PREPARE_INIT,
  REPORT_FILE_ADMIN_DELETE_REPORT_FILE_INIT,
  REPORT_FILE_ADMIN_DELETE_REPORT_FILE_SUCCESS,
  REPORT_FILE_ADMIN_DELETE_REPORT_FILE_FAILURE,
  REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_INIT,
  REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_SUCCESS,
  REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_FAILURE,
  REPORT_FILE_ADMIN_RESET
} from '../../actions/reportFileAdmin/types';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function reportFileAdmin(state = initialState, action) {
  switch (action.type) {    
    case REPORT_FILE_ADMIN_GET_GROUPS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "groupsFilter");
    case REPORT_FILE_ADMIN_GET_GROUPS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "groupsFilter");
    case REPORT_FILE_ADMIN_GET_GROUPS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "groupsFilter");
    case REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "emailHistory");
    case REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "emailHistory");
    case REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "emailHistory");
    case REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "sendReportFileToEmails");
    case REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "sendReportFileToEmails");
    case REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "sendReportFileToEmails");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationUnitsFilter");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationUnitsFilter");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationUnitsFilter");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationUnitsFilterEmailSearch");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationUnitsFilterEmailSearch");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationUnitsFilterEmailSearch");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "calculationUnitsFilterEmailSearchQuery");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "calculationUnitsFilterEmailSearchQuery");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "calculationUnitsFilterEmailSearchQuery");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationUnitsFilterEmail");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationUnitsFilterEmail");
    case REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationUnitsFilterEmail");
    case REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "generateReportFiles");
    case REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "generateReportFiles");
    case REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "generateReportFiles");	
    case REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "reportFilesHistory");
    case REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "reportFilesHistory");
    case REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "reportFilesHistory");	
	  case REPORT_FILE_ADMIN_DELETE_REPORT_FILE_PREPARE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStatePrepareDelete(initialState, state, action, "deleteReportFile");
    case REPORT_FILE_ADMIN_DELETE_REPORT_FILE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitDelete(initialState, state, action, "deleteReportFile");
    case REPORT_FILE_ADMIN_DELETE_REPORT_FILE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessDelete(initialState, state, action, "deleteReportFile");
    case REPORT_FILE_ADMIN_DELETE_REPORT_FILE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureDelete(initialState, state, action, "deleteReportFile");
    case REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "downloadReportFile");
    case REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "downloadReportFile");
    case REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "downloadReportFile");
    case REPORT_FILE_ADMIN_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/reportFileAdmin/index.js